// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeIn {
  0% {
    transform: translateY(-25%);
  }
  50% {
    transform: translateY(4%);
  }
  65% {
    transform: translateY(-2%);
  }
  80% {
    transform: translateY(2%);
  }
  95% {
    transform: translateY(-1%);
  }
  100% {
    transform: translateY(0%);
  }
}

.popup {
  animation-name: fadeIn;
  animation-duration: 0.4s;
  background-clip: padding-box;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);
  left: 0px;
  list-style-type: none;
  margin: 0;
  outline: none;
  padding: 0;
  position: absolute;
  text-align: left;
  top: 0px;
  overflow: hidden;
  -webkit-box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);
}

.popup li {
  clear: both;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.375rem;
  margin: 0;
  padding: 0.313rem 0.75rem;
  transition: all 0.3s;
  white-space: nowrap;
  -webkit-transition: all 0.3s;
}

.popup li:hover {
  background-color: #e6f7ff;
}

.popup li > i {
  margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/popup.css"],"names":[],"mappings":"AAAA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;EACtB,iDAAiD;EACjD,SAAS;EACT,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["@keyframes fadeIn {\n  0% {\n    transform: translateY(-25%);\n  }\n  50% {\n    transform: translateY(4%);\n  }\n  65% {\n    transform: translateY(-2%);\n  }\n  80% {\n    transform: translateY(2%);\n  }\n  95% {\n    transform: translateY(-1%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n}\n\n.popup {\n  animation-name: fadeIn;\n  animation-duration: 0.4s;\n  background-clip: padding-box;\n  background-color: #fff;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);\n  left: 0px;\n  list-style-type: none;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  text-align: left;\n  top: 0px;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);\n}\n\n.popup li {\n  clear: both;\n  color: rgba(0, 0, 0, 0.65);\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: normal;\n  line-height: 1.375rem;\n  margin: 0;\n  padding: 0.313rem 0.75rem;\n  transition: all 0.3s;\n  white-space: nowrap;\n  -webkit-transition: all 0.3s;\n}\n\n.popup li:hover {\n  background-color: #e6f7ff;\n}\n\n.popup li > i {\n  margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
